// src/constants/tables/userTable.config.ts
import { UserColumnConfig } from '@/types/table.types';
import { User } from '@/types/user.types';
import {
  UserNameCell,
  UserSurnameCell,
  UserUsernameCell,
  UserRoleCell,
  UserLastLoginCell,
  UserLastLoginTzCell,
  // UserStatusCell,
  UserMetadataStatusCell,
  UserSubscriptionCell,
  UserSubscriptionExpiryCell,
} from '@/components/features/users/tableCells/UserTableCells';
import { TFunction } from 'i18next';

export const getUserTableColumns = (t: TFunction): UserColumnConfig[] => [
  {
    id: 'personalInfo.name',
    accessor: (row: User) => row.personalInfo.name,
    header: 'pages.users.columns.name',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserNameCell,
    textCase: 'sentence',
  },
  {
    id: 'personalInfo.surname1',
    accessor: (row: User) => row.personalInfo.surname1,
    header: 'pages.users.columns.surname1',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserSurnameCell,
    textCase: 'sentence',
  },
  {
    id: 'credentials.username',
    accessor: (row: User) => row.credentials.username,
    header: 'pages.users.columns.username',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserUsernameCell,
    textCase: 'lowercase',
  },
  {
    id: 'role',
    accessor: 'role',
    header: 'pages.users.columns.role',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserRoleCell,
    getOptionLabel: (option: string) => t(`pages.users.roles.${option.toLowerCase()}`),
  },
  /*
  {
    id: 'timezone',
    accessor: 'timezone',
    header: 'pages.users.columns.timezone',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserTimezoneCell,
  },
  */
  {
    id: 'sessionManagement.lastLogin',
    accessor: (row: User) => row.sessionManagement?.lastLogin,
    header: 'pages.users.columns.lastLogin',
    cell: UserLastLoginCell,
  },
  {
    id: 'sessionManagement.lastLoginTz',
    accessor: (row: User) => row.sessionManagement?.lastLoginTz,
    header: 'pages.users.columns.lastLoginZone',
    cell: UserLastLoginTzCell,
  },
  {
    id: 'metadata.status',
    accessor: (row: User) => row.metadata?.status,
    header: 'pages.users.columns.status',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserMetadataStatusCell,
    getOptionLabel: (option: string) => t(`status.${option.toLowerCase()}`),
  },
  {
    id: 'metadata.subscription',
    accessor: (row: User) => row.metadata?.subscription,
    header: 'pages.users.columns.subscription',
    enableSorting: true,
    enableFilter: true,
    filterType: 'select',
    cell: UserSubscriptionCell,
    getOptionLabel: (option: string) => t(`pages.users.subscription.${option.toLowerCase()}`),
  },
  {
    id: 'metadata.subscriptionExpiryDate',
    accessor: (row: User) => row.metadata?.subscriptionExpiryDate,
    header: 'pages.users.columns.subscriptionExpiryDate',
    enableSorting: true,
    cell: UserSubscriptionExpiryCell,
  },
];
